import { render } from "./calendar-main.html?vue&type=template&id=3b29e378&scoped=true&ts=true&external"
import script from "./calendar-main.ts?vue&type=script&lang=ts&external"
export * from "./calendar-main.ts?vue&type=script&lang=ts&external"

import "./calendar-main.scss?vue&type=style&index=0&id=3b29e378&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b29e378"]])

export default __exports__